import React, { useEffect, useState } from "react";
import "./SectionInput.css";
import { Accordion, CardImg } from "react-bootstrap";
import InputText from "./formelement/InputText";
import { useDispatch, useSelector } from "react-redux";
import { deleteSection, updateSection } from "../../REDUX/actions/section";

import Uploader from "../Common/Uploader";
import Lists from "../Lists/Lists";
import _ from "lodash";
import CustomSelect from "./formelement/CustomSelect";
import CustomButton from "../Common/CustomButton";
import { openModal } from "../../REDUX/actions/confirmationModal";
import LoadingButton from "../Common/LoadingButton";

const SectionInput = ({
  titleOrange,
  titleBlack,
  sectionData = {},
  withSeo = false,
  sectionId,
  defaultExpand,
  shadowed = true,
  deleteButton,
  type,
  eventItemForm,
  noBtn,
  fetchProduct,
  image2LabelInput,
  customSaveHandler,
  contentLabel,
  titleLabelInput,
  isProductBanner = false,
}) => {
  const dispatch = useDispatch();
  const [image, setimage] = useState(sectionData.image?.data);
  const [image2, setimage2] = useState(sectionData.image2?.data);
  const [image3, setimage3] = useState(sectionData.image3?.data);
  const [imageMobile, setImageMobile] = useState(sectionData.imageMobile?.data);
  const [imageMobile2, setImageMobile2] = useState(
    sectionData.imageMobile2?.data,
  );
  // here showButton

  const [buttonUrl, setbuttonUrl] = useState(sectionData.buttonUrl || "/");
  const { sectionLoading } = useSelector((state) => state.pagesReducer);
  const [formData, setformData] = useState({
    ..._.omit(sectionData, [
      "image",
      "image2",
      "image3",
      "imageMobile",
      "imageMobile2",
      "createdAt",
      "updatedAt",
      "list",
      "locale",
      "article",
      "carousel",
      "event",
      "page",
      "product",
      "revendeur",
      "resolution",
      "productjets",
      "articleBanner",
      "eventBanner",
    ]),
    showButton:
      sectionData.showButton !== undefined ? sectionData.showButton : true,
    buttonText: sectionData.buttonText || "Texte du bouton",
  });
  useEffect(() => {
    setformData({
      ..._.omit(sectionData, [
        "image",
        "image2",
        "image3",
        "imageMobile",
        "imageMobile2",
        "createdAt",
        "updatedAt",
        "list",
        "locale",
        "article",
        "carousel",
        "event",
        "page",
        "product",
        "revendeur",
        "resolution",
        "productjets",
        "articleBanner",
        "eventBanner",
      ]),
      showButton:
        sectionData.showButton !== undefined ? sectionData.showButton : true,
      buttonText: sectionData.buttonText || "Texte du bouton",
    });
    setimage(sectionData.image?.data);
    setimage2(sectionData.image2?.data);
    setimage3(sectionData.image3?.data);
    setImageMobile(sectionData?.imageMobile?.data);
    setImageMobile2(sectionData?.imageMobile2?.data);
    setbuttonUrl(sectionData.buttonUrl || "/");
    // eslint-disable-next-line
  }, [sectionData]);

  const handleSubmit = () => {
    if (customSaveHandler) {
      customSaveHandler({ ...formData, buttonUrl }, image, image2, image3);
    } else {
      dispatch(
        updateSection(
          {
            ...formData,
            buttonUrl: buttonUrl,
            image: image?.id,
            image2: image2 ? image2.id : null,
            image3: image3 ? image3.id : null,
            imageMobile: imageMobile?.id,
            imageMobile2: imageMobile2?.id,
          },
          sectionId,
        ),
      );
    }
  };
  const handleChange = (value, champs) => {
    setformData({ ...formData, [champs]: value });
  };

  const handleChangeButtonUrl = (value) => {
    setbuttonUrl(value);
  };

  const handleImage = (imageSelected) => {
    setimage(imageSelected);
  };
  const handleImage2 = (imageSelected) => {
    setimage2(imageSelected);
  };
  const handleImage3 = (imageSelected) => {
    setimage3(imageSelected);
  };
  const handleImageMobile = (imageSelected) => {
    setImageMobile(imageSelected);
  };
  const handleImageMobile2 = (imageSelected) => {
    setImageMobile2(imageSelected);
  };
  /*  const handleButtonShow = (value) => {
    setformData({ ...formData, showButton: value });
  }; */

  const handleDelete = () => {
    dispatch(deleteSection(sectionId, eventItemForm.id, type));
  };

  const showModalDelete = () => {
    dispatch(
      openModal({
        type: "delete",
        confirmButtonText: "Supprimer",
        cancelButton: true,
        message: "Êtes-vous sûr(e) de vouloir supprimer la section ?",
        callBack: handleDelete,
      }),
    );
  };

  console.log({
    sectionData,
  });

  return (
    <Accordion
      className={`text-start rounded-10 ${shadowed ? "shadowed" : ""}`}
      defaultActiveKey={defaultExpand ? "0" : null}
    >
      <Accordion.Item
        className="card-body noBorder p-0 rounded-10"
        eventKey="0"
      >
        <Accordion.Header className="rounded-10">
          <h2 className="text-orange mb-0 f24 fw-bold">{titleOrange}</h2>
          <h2 className="mb-0 f24 fw-normal">{titleBlack}</h2>
        </Accordion.Header>

        <Accordion.Body>
          <div className="container-fluid">
            <div className="row my-5">
              {sectionData.regularTitle !== null ? (
                <div className="col-6">
                  <InputText
                    labelinput="Titre Régulier"
                    value={formData.regularTitle}
                    handleChange={handleChange}
                    champs="regularTitle"
                  />
                </div>
              ) : null}
              {sectionData.decoratedTitle !== null ? (
                <div className="col-6">
                  <InputText
                    labelinput="Titre Italique Bleu"
                    value={formData.decoratedTitle}
                    handleChange={handleChange}
                    champs="decoratedTitle"
                  />
                </div>
              ) : null}
            </div>
            <div className="row align-items-center">
              {sectionData.image !== undefined &&
                sectionId !== 63 &&
                sectionId !== 2 &&
                sectionId !== 3 &&
                sectionId !== 66 &&
                sectionId !== 5 &&
                sectionId !== 10 &&
                sectionId !== 7 &&
                sectionId !== 1 && (
                  <div className="col-6  d-flex flex-column align-items-center justify-content-center gap-5 mb-5">
                    <div className="row gap-3 w-100">
                      <div className="col mx-w-280">
                        <Uploader
                          handleImage={handleImage}
                          image={image}
                          resolution={sectionData.resolution}
                          targetScreen="desktop"
                        />
                      </div>
                      {!isProductBanner &&
                        sectionId !== 155 &&
                        sectionId !== 1 &&
                        sectionId !== 2 &&
                        sectionId !== 3 &&
                        sectionId !== 66 &&
                        sectionId !== 67 &&
                        sectionId !== 8 &&
                        sectionId !== 10 &&
                        sectionId !== 11 &&
                        sectionId !== 12 &&
                        sectionId !== 13 &&
                        sectionId !== 14 &&
                        sectionId !== 15 &&
                        sectionId !== 6 &&
                        sectionId !== 7 &&
                        sectionId !== 9 && (
                          <div className="col mx-w-280">
                            <Uploader
                              handleImage={handleImage2}
                              image={image2}
                              labelinput={image2LabelInput}
                              targetScreen="desktop 2"
                            />
                          </div>
                        )}
                      {!isProductBanner &&
                        sectionId !== 155 &&
                        sectionId !== 1 &&
                        sectionId !== 2 &&
                        sectionId !== 3 &&
                        sectionId !== 67 &&
                        sectionId !== 8 &&
                        sectionId !== 10 &&
                        sectionId !== 11 &&
                        sectionId !== 12 &&
                        sectionId !== 13 &&
                        sectionId !== 14 &&
                        sectionId !== 15 &&
                        sectionId !== 6 &&
                        sectionId !== 7 &&
                        sectionId !== 9 && (
                          <div className="col mx-w-280">
                            <Uploader
                              handleImage={handleImage3}
                              image={image3}
                              targetScreen="desktop 3"
                            />
                          </div>
                        )}

                      {imageMobile && (
                        <div className="col mx-w-280">
                          <Uploader
                            handleImage={handleImageMobile}
                            image={imageMobile}
                            resolution={sectionData.resolution}
                            targetScreen="mobile "
                          />
                        </div>
                      )}
                      {imageMobile2 && sectionId !== 13 && (
                        <div className="col mx-w-280">
                          <Uploader
                            handleImage={handleImageMobile2}
                            image={imageMobile2}
                            targetScreen="2 mobile"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              <div className="col ">
                {sectionId !== 1 &&
                  sectionId !== 63 &&
                  sectionId !== 3 &&
                  sectionId !== 67 &&
                  sectionId !== 11 &&
                  sectionId !== 12 &&
                  sectionId !== 13 &&
                  sectionId !== 14 &&
                  sectionId !== 15 &&
                  sectionId !== 7 &&
                  sectionId !== 6 &&
                  sectionId !== 155 && (
                    <InputText
                      labelinput="Titre"
                      value={formData.title}
                      handleChange={handleChange}
                      champs="title"
                    />
                  )}

                {sectionData.subtitle !== null &&
                sectionId !== 5 &&
                sectionData.subtitle?.length > 0 ? (
                  <InputText
                    labelinput="Sous-Titre"
                    value={formData.subtitle}
                    handleChange={handleChange}
                    champs="subtitle"
                  />
                ) : null}
                {!noBtn && (
                  <>
                    <div className="row mt-3 align-items-start">
                      {/*    <div className="col-2">
                        <label className="f16 ">Afficher Bouton </label>
                        <Form.Switch
                          key={Math.random()}
                          defaultChecked={formData.showButton}
                          onChange={(e) => handleButtonShow(e.target.checked)}
                        ></Form.Switch>
                      </div> */}

                      {formData.showButton &&
                        sectionId !== 2 &&
                        sectionId !== 5 &&
                        sectionId !== 67 &&
                        sectionId !== 8 &&
                        sectionId !== 10 &&
                        sectionId !== 13 &&
                        sectionId !== 6 &&
                        sectionId !== 9 &&
                        !isProductBanner && (
                          <div className="col">
                            <CustomSelect
                              handleChange={handleChangeButtonUrl}
                              value={buttonUrl}
                            />
                          </div>
                        )}
                    </div>
                    {formData.showButton && sectionId !== 6 && (
                      <div className="row pt-2 pb-2">
                        <div className="col">
                          <InputText
                            labelinput="Texte du bouton"
                            value={formData.buttonText}
                            handleChange={handleChange}
                            champs="buttonText"
                          />
                        </div>
                        <div className="col">
                          <InputText
                            labelinput="URL du bouton"
                            value={buttonUrl}
                            // flag={false}
                            handleChange={handleChangeButtonUrl}
                            champs="buttonUrl"
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              {sectionData.description !== null && sectionId !== 63 ? (
                <div className="col-12">
                  <InputText
                    labelinput="Description"
                    textArea
                    value={formData.description}
                    handleChange={handleChange}
                    champs="description"
                  />
                </div>
              ) : null}
              {sectionData.content !== null || withSeo ? (
                <div className="col-12">
                  <InputText
                    labelinput={
                      contentLabel ||
                      (withSeo ? "text SEO (affiché en bas de page)" : "")
                    }
                    textArea
                    value={formData.content}
                    handleChange={handleChange}
                    champs="content"
                  />
                </div>
              ) : null}
            </div>
            <div className="row">
              <div className="col">
                {sectionId !== 63 &&
                  sectionId !== 7 &&
                  sectionId !== 3 &&
                  sectionId !== 1 && (
                    <CustomButton
                      disabled={sectionLoading}
                      buttonText={
                        sectionLoading ? <LoadingButton /> : "Enregistrer"
                      }
                      callBack={handleSubmit}
                    />
                  )}
              </div>
              {deleteButton && (
                <div className="col-4">
                  <CustomButton
                    buttonText="Supprimer la section"
                    iconStart="trash-fill"
                    type="red"
                    callBack={showModalDelete}
                  />
                </div>
              )}
            </div>

            {sectionData.list?.data && (
              <Lists
                listData={sectionData.list.data}
                fetchProduct={fetchProduct}
              />
            )}
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default SectionInput;
